import { render, staticRenderFns } from "./mergeOrders.vue?vue&type=template&id=42bfa3c8&scoped=true&"
import script from "./mergeOrders.vue?vue&type=script&lang=js&"
export * from "./mergeOrders.vue?vue&type=script&lang=js&"
import style0 from "./mergeOrders.vue?vue&type=style&index=0&id=42bfa3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bfa3c8",
  null
  
)

export default component.exports